import React, { useState, useEffect, useContext } from "react";
import { Table } from "./components/Table";
import { useDebounce, useFetch } from "../../utils/hooks";
import styles from "../styles/Registers.module.css";
import { Heading } from "./components/Heading";
import { medicalReportsService } from "../../services/medicalReports";
import { OrdinationsAndCountriesContext } from "../../contexts/ordinationsAndCountriesContext";

import {ModalChoseOrdination} from '../../components/ModalChoseOrdination'

export const MedicalReports = () => {
  const [searchValue, setSearchValue] = useState("");
  const [orderValue, setOrderValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const size = localStorage.getItem("pageSizeMedicalReports")
    ? localStorage.getItem("pageSizeMedicalReports")
    : 20;
  const [pageSize, setPageSize] = useState(size);
  const [selectorValue, setSelectorValue] = useState("");
  const [visibleAddModal, setVisibleAddModal] = useState(false);
  const debouncedSearchValue = useDebounce(searchValue);
  const debouncedSelectorValue = useDebounce(selectorValue);
  const { ordinationId } = useContext(OrdinationsAndCountriesContext);
  const [loadingSelectData, selLoadingSelectData] = useState(false);

  const loadMedicalReports =  (cancelToken) =>
     medicalReportsService.getMedicalReportsPaged({
      currentPage,
      pageSize,
      searchValue: debouncedSearchValue,
      selectorValue: debouncedSelectorValue,
      cancelToken,
      orderValue,
      finished:true
    });
  const [
    {
      data: { results: medicalReports, count: totalRows },
      isFetching,
    },
    getMedicalReports,
  ] = useFetch(loadMedicalReports);
  const loading = (ordinationId === undefined || isFetching || (totalRows===null))
 
  useEffect(() => {
    setCurrentPage(1);
    setOrderValue("");
  }, [debouncedSearchValue]);

  useEffect(() => {
    getMedicalReports();
  }, [
    debouncedSearchValue,
    debouncedSelectorValue,
    pageSize,
    currentPage,
    getMedicalReports,
    orderValue,
    ordinationId,
  ]);
  return (
    <div className={styles.registers}>
      <h1>Izvještaji</h1>

      <div //className={styles.medicalReportFormBoxes}
      >
        <Heading
          searchValue={searchValue}
          selectorValue={selectorValue}
          onChangeSelector={(value) => setSelectorValue(value)}
          onSearch={(search) => setSearchValue(search)}
          onCreateRegisterClicked={() => setVisibleAddModal(true)}
        />
        <ModalChoseOrdination></ModalChoseOrdination> 
        <Table
          medicalReports={medicalReports}
          loading={loading}
          totalRows={totalRows}
          currentPage={currentPage}
          pageSize={pageSize}
          onClone={getMedicalReports}
          onEdit={getMedicalReports}
          onDelete={getMedicalReports}
          orderValue={orderValue}
          setOrderValue={(order) => setOrderValue(order)}
          onPaginationChange={(page) => setCurrentPage(page)}
          onPageSizeChange={(size) => {
            setCurrentPage(1);
            setPageSize(size);
            localStorage.setItem("pageSizeMedicalReports", size);
          }}
        />
      </div>
    </div>
  );
};
